import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Leaf } from "@phosphor-icons/react";

export default function SignupPage() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 6) {
      setError("Password must be at least 6 characters");
      return;
    }
    setSubmitting(true);
    const result = await register(name, email, password);
    setSubmitting(false);
    if (result.success) {
      navigate("/pricing");
    } else {
      setError(result.error);
    }
  };

  return (
    <div className="min-h-screen bg-leather flex items-center justify-center p-4" data-testid="signup-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#55624F] mb-4">
            <Leaf size={32} weight="duotone" className="text-[#F5F4F0]" />
          </div>
          <h1 className="font-['Cormorant_Garamond'] text-3xl font-bold text-white">Create Account</h1>
          <p className="text-white/70 mt-1 font-['Manrope']">Start your Nature Journal today</p>
        </div>

        <form onSubmit={handleSubmit} className="bg-white/95 backdrop-blur-sm rounded-2xl shadow-lg border border-[#D2C2B3] p-8 space-y-5">
          {error && (
            <div className="bg-red-50 text-red-700 px-4 py-3 rounded-lg text-sm" data-testid="signup-error">
              {error}
            </div>
          )}

          <div>
            <label className="block text-sm font-medium text-[#2C3E2D] mb-1.5 font-['Manrope']">Name</label>
            <Input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Your name"
              required
              data-testid="signup-name-input"
              className="bg-[#FAFAF8] border-[#E8E6E1] focus:border-[#55624F] focus:ring-[#55624F]"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-[#2C3E2D] mb-1.5 font-['Manrope']">Email</label>
            <Input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              required
              data-testid="signup-email-input"
              className="bg-[#FAFAF8] border-[#E8E6E1] focus:border-[#55624F] focus:ring-[#55624F]"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-[#2C3E2D] mb-1.5 font-['Manrope']">Password</label>
            <Input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="At least 6 characters"
              required
              data-testid="signup-password-input"
              className="bg-[#FAFAF8] border-[#E8E6E1] focus:border-[#55624F] focus:ring-[#55624F]"
            />
          </div>

          <Button
            type="submit"
            disabled={submitting}
            data-testid="signup-submit-btn"
            className="w-full bg-[#55624F] hover:bg-[#3d4738] text-white py-2.5 rounded-xl font-['Manrope'] font-semibold"
          >
            {submitting ? "Creating account..." : "Create Account"}
          </Button>

          <p className="text-center text-sm text-[#7C8068] font-['Manrope']">
            Already have an account?{" "}
            <Link to="/login" className="text-[#C25A3C] hover:underline font-medium" data-testid="login-link">
              Sign in
            </Link>
          </p>
        </form>
      </div>
    </div>
  );
}
